
import css from './InformationCard.module.scss';
import { strings } from 'src/localization';
import React from 'react';
export interface IProps {
    theme: string;
    children: React.ReactNode;
    onEdit: (e: any, id?: string) => void;
    nameId: string;
    identityVerified: boolean;
    mfaEnabled: boolean | undefined;
    selectedVehicle: string;
}

const InformationCard = (props: IProps) => {
    let summaryCardCss = css.summaryCard;

    if (props.theme === 'bmw') {
        summaryCardCss = css.summaryCardBMW;
    } else if (props.theme === 'toyotaSPM') {
        summaryCardCss = css.summaryCardSPM;
    } else if (props.theme === 'lexusMonogram') {
        summaryCardCss = css.summaryCardLM;
    } else if (props.theme === 'cadillac') {
        summaryCardCss = css.summaryCardCA;
    }

    // Handling an undefined nameID and setting to selectedVehicle in order to display Edit button for MFA.
    let apptNameId = props.nameId;
    if (apptNameId === undefined && props.selectedVehicle) {
        apptNameId = props.selectedVehicle;
    }

    return (
        <div className={css.flexItemLeft}>
            <div className={css.container}>
                <h4 className={css.summaryTitle}>
                    {strings.Information}
                </h4>
                {apptNameId && !props.identityVerified && props.mfaEnabled &&
                        <span
                            id='edit'
                            className={css.editLink}
                            onClick={(e: any) => props.onEdit(e)}
                        >
                            {strings.Edit}
                        </span>
                }
            </div>

            <div className={summaryCardCss}>
                {props.children}
            </div>
        </div>
    );
};


export default InformationCard;